// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 762) return "chunks/frontend/frontend-photoswipe.d31ebfa562ea52c8ccda.js";
	// return url for filenames based on template
	return undefined;
};